App.controller('ZochFileListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaReportService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'profileService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaReportService, $timeout, $stateParams, Blob, FileSaver, profileService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_file';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista plików';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.files = [
        {
            name: "Przykładowy plik pdf",
            creationTime: "30.07.2017"
        },
        {
            name: "Przykładowy plik pdf",
            creationTime: "30.07.2017"
        },
        {
            name: "Przykładowy plik doc",
            creationTime: "30.07.2017"
        },
        {
            name: "Przykładowy plik xlsx",
            creationTime: "30.07.2017"
        },
        {
            name: "Przykładowy plik doc",
            creationTime: "30.07.2017"
        }
    ];    
}]);